import { useQuery } from '@tanstack/react-query';
import { AuditLogsService, GetListAuditLogEntity } from 'services/openapi';

import { AuditLogsServiceQueryKeys } from '../constants';
import { isEmpty } from 'lodash';

export type GetAuditLogsAdminDTO = {
  page: string;
  pageSize?: string;
  actorId?: string;
  action?: string | undefined;
  startDate: string;
  endDate: string;
};

export const useGetAuditLogsAdminQuery = (variables: GetAuditLogsAdminDTO) => {
  const queryKey = [AuditLogsServiceQueryKeys.GET_AUDIT_LOGS_LIST, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListAuditLogEntity, Error>({
    queryKey,
    queryFn: () =>
      AuditLogsService.auditlogControllerListAuditLogs(
        variables.startDate,
        variables.endDate,
        variables.page,
        variables.pageSize,
        variables.actorId,
        variables.action,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !isEmpty(variables),
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
